import Vue from "vue";
import Tooltip from "../components/shared/Tooltip.vue";

const MyTooltip = Vue.extend(Tooltip);

const tooltipDirective = {};
tooltipDirective.install = Vue => {
  Vue.directive("tooltip", {
    bind(el, binding) {
      const textExr = analyzeText(el, binding);
      if (!textExr) return;

      const placement = analyzeModifiers(el, binding);

      const tooltip = new MyTooltip({
        el: document.createElement("div"),
        data: {
          text: textExr,
          placement: placement
        }
      });

      el.instance = tooltip;
      el.tooltip = tooltip.$el;
      addEvents(el, binding, placement);
    },

    update(el, binding) {
     if(binding.value !== binding.oldValue) {
       const textExr = analyzeText(el, binding);
       if (!textExr) return;

       const placement = analyzeModifiers(el, binding);

       const tooltip = new MyTooltip({
         el: document.createElement("div"),
         data: {
           text: textExr,
           placement: placement
         }
       });

       el.instance = tooltip;
       el.tooltip = tooltip.$el;
       addEvents(el, binding, placement);
     }
    },

    unbind(el) {
      if (el.tooltip && el.tooltip.parentNode) {
        el.tooltip.parentNode.removeChild(el.tooltip);
        el.tooltip = null;
      }
      if (el.instance) el.instance.$destroy();
    }
  });

  const analyzeModifiers = (el, binding) => {
    const POSITIONS = ["left", "right"];

    let [placement = "right"] = [];
    for (const item in binding.modifiers) {
      if (POSITIONS.includes(item)) {
        placement = item;
      }
    }
    return placement;
  };

  const analyzeText = (el, binding) => {
    const { value } = binding;
    const title = el.getAttribute("title");

    let textExr = "";
    if (!value) {
      const hasTitle = title && typeof title === "string";
      if (!hasTitle) return false;

      textExr = title; // automatically convert all the title to tooltip
      el.setAttribute("title", "");
    } else {
      textExr = value;
    }

    return textExr;
  };

  const addEvents = (el, binding, placement) => {
    const addTooltip = e => {
      if (!el.tooltip) return;
      document.body.appendChild(el.tooltip);
      el.instance.visible = true;
      Vue.nextTick(() => {
        createStyleForTooltip();
      });
    };

    const hideTooltip = () => {
      el.instance.visible = false;
    };

    const removeTooltip = e => {
      if (!el.instance.visible) {
        document.body.removeChild(el.tooltip);
      }
    };

    const createStyleForTooltip = () => {
      Object.assign(el.tooltip.style, {
        transform: getTransform(),
        position: "absolute",
        top: "0",
        left: "0",
        "z-index": "1000"
      });
    };

    const getTransform = () => {
      const reference = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const element = el.tooltip.getBoundingClientRect();

      if (placement === "left") {
        return `translate(${Math.round(reference.left + scrollLeft - element.width + 35)}px, ${Math.round(
          reference.top + scrollTop - element.height - 15)}px)`;
      }
      return `translate(${Math.round(reference.left + scrollLeft - 9)}px, ${Math.round(
        reference.top + scrollTop - element.height - 15)}px)`;
    };

    el.addEventListener("mouseenter", addTooltip, false);
    el.addEventListener("mouseleave", hideTooltip, false);
    el.tooltip.addEventListener("transitionend", removeTooltip, false);
  };
};

export default tooltipDirective;
